import { Row, Col } from 'reactstrap';

import icon1 from '../../assets/images/institute Dashboard Icons/income-w.png';
import verified from '../../assets/images/tiles/verified.png';
import icon2 from '../../assets/images/institute Dashboard Icons/expense-w.png';
import costpersale from '../../assets/images/tiles/costpersale.png'
import icon3 from '../../assets/images/institute Dashboard Icons/assets-w.png';
import costperapp from '../../assets/images/tiles/costperapp.png'
import icon4 from '../../assets/images/institute Dashboard Icons/staff-w.png';
import disbursed from '../../assets/images/tiles/disbursed.png'

const ApiAnalyticsTopCards = ({ data, loading }) => {
    if (loading || !data) {
        return <div>Loading...</div>; // or your existing loading UI
    }
    const mappedData = {
        approvalPercentage: data.approvalPercentage || 0,
        costPerSale: data.costPerSale || 0,
        costPerApplication: data.costPerApplication || 0,
        disbursed: data.disbursed_count || 0
    };
    return (
        <>
            <Row className="g-3">
                {/* Approval Percentage Card */}
                <Col sm="6" lg="3">
                    <div
                        style={{
                            backgroundColor: "#3e7bf0",
                            padding: "1rem",
                            borderRadius: "8px",
                            border: "1px solid #d4d6d5",
                            color: "#fff",
                            height: "100%",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <img
                                src={verified}
                                alt="icon"
                                style={{ marginRight: "10px", width: "35px", height: "35px", filter: "brightness(0) invert(1)" }}
                            />
                            <div>
                                <p style={{ margin: 0 }}>Approval Percentage</p>
                                <h5 style={{ margin: 0 }}>{mappedData.approvalPercentage}%</h5>
                            </div>
                        </div>
                    </div>
                </Col>

                {/* Cost Per Sale Card */}
                <Col sm="6" lg="3">
                    <div
                        style={{
                            backgroundColor: "#40d89f",
                            padding: "1rem",
                            borderRadius: "8px",
                            border: "1px solid #d4d6d5",
                            color: "#fff",
                            height: "100%",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <img
                                src={costpersale}
                                alt="icon"
                                style={{
                                    marginRight: "10px", width: "40px", height: "40px", filter: "brightness(0) invert(1)"}}
                            />
                            <div>
                                <p style={{ margin: 0 }}>Cost Per Sale</p>
                                <h5 style={{ margin: 0 }}>₹{mappedData.costPerSale}</h5>
                            </div>
                        </div>
                    </div>
                </Col>

                {/* Cost Per App Card */}
                <Col sm="6" lg="3">
                    <div
                        style={{
                            backgroundColor: "#7857f0",
                            padding: "1rem",
                            borderRadius: "8px",
                            border: "1px solid #d4d6d5",
                            color: "#fff",
                            height: "100%",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <img
                                src={costperapp}
                                alt="icon"
                                style={{
                                    marginRight: "10px", width: "35px", height: "35px", filter: "brightness(0) invert(1)"
 }}
                            />
                            <div>
                                <p style={{ margin: 0 }}>Cost Per App</p>
                                <h5 style={{ margin: 0 }}>₹{mappedData.costPerApplication}</h5>
                            </div>
                        </div>
                    </div>
                </Col>

                {/* Disbursed Card */}
                <Col sm="6" lg="3">
                    <div
                        style={{
                            backgroundColor: "#E7514C",
                            padding: "1rem",
                            borderRadius: "8px",
                            border: "1px solid #d4d6d5",
                            color: "#fff",
                            height: "100%",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <img
                                src={disbursed}
                                alt="icon"
                                style={{ marginRight: "10px", width: "40px", height: "40px", filter: "brightness(0) invert(1)" }}
                            />
                            <div>
                                <p style={{ margin: 0 }}>Disbursed</p>
                                <h5 style={{ margin: 0 }}>{mappedData.disbursed}</h5>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default ApiAnalyticsTopCards;